import api from "@/vue-dlb/utils/backend-api";
import ObjDataSet from "@/vue-dlb/models/objdataset";
import ObjTrSet from "@/vue-dlb/models/objtrset";
import appUtil from '@/vue-dlb/utils/app-util'
import {UploadFile} from '@/vue-dlb/models'
import config from '@/vue-caas/config/config.js';

import {
  commitRetDataSets,
  showProgress
} from "@/vue-dlb/utils/sys-util.js";

import {
  selectDataSetByDataSet,
  execSPByDataSet,
  callByDataSet,
  selectUserDataSet,
} from "@/vue-dlb/utils/backend-util.js";

import { get } from "lodash";

const isDlbMybatis = config.isDlbMybatis;

const state = {
  mainGrid: [],
  dataSet01Source: [],
};

const getters = {
};

const actions = {
  queryList: async ({ commit }, searchItems) => {
    const retSet = new ObjDataSet("mainGrid");
    let condSet = new ObjDataSet("condSet");
    const trSet = new ObjTrSet("queryList");
    condSet = appUtil.addDataHeader(searchItems, condSet);
    trSet.AddDataSet("I", "DS01", condSet);
    trSet.AddDataSet("O", "DS02", retSet);
    // 203737 SPKA-49 issue 5 apply date conndition
    trSet.tranID = "EDP_REF_LIST_MAN_ATFT_MST_FN";
    trSet.suiParam = "USER_TIMEZONE";
    const reqdata = selectDataSetByDataSet(trSet);
    await api.putData("UserDispatcherServlet", reqdata).then(res => {
      commitRetDataSets(commit, res.data);
    });
  },
  saveAddReferenceFiles: async ({ commit }, paramItems) => {
    for(let i = 0; i < paramItems.data.length; i++) {
      if(paramItems.data[i].SYSSTATUS == 'I' && paramItems.data[i].ADDBY == 'LOCAL') {
        // Local에서 업로드 하는 파일들만 먼저 서버에 업로드 하기
        let uploadfile = new UploadFile();
        uploadfile.data[0].DIV_KUBUN = 'ASSET';
        uploadfile.data[0].BIZ_KUBUN = 'FILE_ATFT';
        uploadfile.data[0].SITE_CODE = paramItems.data[i].CUST_ID;
        uploadfile.data[0].USER_KUBUN = $cookies.get('comp-id');
        uploadfile.data[0].SUB_DIR = '';
        uploadfile.data[0].RENAME_YN = 'Y';
        uploadfile.data[0].FILE_NAME = paramItems.data[i].file.name;
        uploadfile.data[0].file = paramItems.data[i].file;
        // Upload EDI File Data
        const retSet = new ObjDataSet("UploadedFile");
        let condSet = new ObjDataSet("condSet");
        let trSet = new ObjTrSet("saveAddReferenceFiles");
        condSet = appUtil.addDataHeader(uploadfile, condSet);
        trSet.AddDataSet("I", "DS01", condSet);
        trSet.AddDataSet("O", "DS02", retSet);
        trSet = selectUserDataSet(trSet);   // call directly only for uploading file.
        const formData = new FormData();
        formData.append('file', uploadfile.data[0].file, uploadfile.data[0].FILE_NAME);
        formData.append('trSet', JSON.stringify(trSet));
        await api.trFileSend("Fileupload", formData).then(res => {
          let resdata = res.data;
          var trset = JSON.parse(JSON.stringify(resdata));
          var datasets = trset.DataSets;
          var datarows = datasets[0].DataRows;
          //////////////// 업로드 후 부여받은 FILE ID를 SET해주기 //////////////
          paramItems.data[i].FILE_ID = datarows[0].FILE_NAME;  // Server file ID
        });
      } // if(paramItems.data[i].SYSSTATUS == 'I' && paramItems.data[i].ADDBY == 'LOCAL')
    } // for

    // Load일 경우 파일을 Copy하기 위해 서버에 디렉토리 설정을 위해 UploadFile객체 같이 보내기
    let uploadfile = new UploadFile();
    uploadfile.data[0].DIV_KUBUN = 'ASSET';
    uploadfile.data[0].BIZ_KUBUN = 'FILE_ATFT';
    uploadfile.data[0].SITE_CODE = paramItems.data[0].CUST_ID;
    uploadfile.data[0].USER_KUBUN = $cookies.get('comp-id');
    uploadfile.data[0].SUB_DIR = '';
    uploadfile.data[0].RENAME_YN = 'Y';
    uploadfile.data[0].FILE_NAME = '';
    uploadfile.data[0].file = '';
    let fileSet = new ObjDataSet("fileSet");
    fileSet = appUtil.addDataHeader(uploadfile, fileSet);
    /////////////////////////
    let condSet = new ObjDataSet("condSet");
    const trSet = new ObjTrSet("saveAddReferenceFiles");
    condSet = appUtil.addDataHeader(paramItems, condSet);
    trSet.AddDataSet("I", "DS01", condSet);
    trSet.AddDataSet("I", "DS02", fileSet);
    trSet.tranID = "ResourceManager";
    trSet.tranMethod = "saveAddReferenceFiles";
    const reqdata = callByDataSet(trSet);
    await api.putData("UserDispatcherServlet", reqdata).then(res => {
    });
  },
  modifyReferenceFiles: async ({ commit }, paramItems) => {
    let condSet = new ObjDataSet("condSet");
    const trSet = new ObjTrSet("modifyReferenceFiles");
    condSet = appUtil.addDataHeader(paramItems, condSet);
    trSet.AddDataSet("I", "DS01", condSet);
    trSet.tranID = "ResourceManager";
    trSet.tranMethod = "modifyReferenceFiles";
    const reqdata = callByDataSet(trSet);
    await api.putData("UserDispatcherServlet", reqdata).then(res => {
    });
  },
  deleteReferenceFiles: async ({ commit }, paramItems) => {
    let condSet = new ObjDataSet("condSet");
    const trSet = new ObjTrSet("deleteReferenceFiles");
    condSet = appUtil.addDataHeader(paramItems, condSet);
    trSet.AddDataSet("I", "DS01", condSet);
    trSet.tranID = "ResourceManager";
    trSet.tranMethod = "deleteReferenceFiles";
    const reqdata = callByDataSet(trSet);
    await api.putData("UserDispatcherServlet", reqdata).then(res => {
    });
  },
  deleteRepoReferenceFiles: async ({ commit }, paramItems) => {
    let condSet = new ObjDataSet("condSet");
    const trSet = new ObjTrSet("deleteRepoReferenceFiles");
    condSet = appUtil.addDataHeader(paramItems, condSet);
    trSet.AddDataSet("I", "DS01", condSet);
    trSet.tranID = "ResourceManager";
    trSet.tranMethod = "deleteRepoReferenceFiles";
    const reqdata = callByDataSet(trSet);
    await api.putData("UserDispatcherServlet", reqdata).then(res => {
    });
  },
  updateLock: async ({ commit }, paramItems) => {
    let condSet = new ObjDataSet("condSet");
    const trSet = new ObjTrSet("updateLock");
    condSet = appUtil.addDataHeader(paramItems, condSet);
    trSet.AddDataSet("I", "DS01", condSet);
    let reqdata = ''
    if (isDlbMybatis) {
      trSet.tranID = "MapDefinitionManager";
      trSet.tranMethod = "updateLock";
      reqdata = callByDataSet(trSet);
    } else {
      trSet.tranID = "EDP_MPD_UPD_MAN_MPD_LOCK_SP";
      trSet.suiParam = "USER_IDNO";
      reqdata = execSPByDataSet(trSet);
    }
    await api.putData("UserDispatcherServlet", reqdata).then(res => {
    });
  },
};

const mutations = {
  mainGrid (state, datarows) {
    state.mainGrid = datarows;
    state.dataSet01Source = datarows;
  },
  'SET_REFERENCS_FILTER' (state, filter) {
    let datarows = state.dataSet01Source;
    state.filter = filter;
    let filterBy = state.filter;
    let listResult = [];
    if (filterBy != null) {
      let filter = filterBy.filter;
      let str = filterBy.str;
      if (str.trim() == '') {
        listResult = datarows;
      }
      listResult = datarows.filter(item =>  {
        if(filter == 'all') {
          for (const prop in item) {
            if (typeof item[prop] == 'string') {
              let propValue = item[prop].toLowerCase();
              let queryValue = str.toLowerCase();
              if (propValue.includes(queryValue)) {
                return true;
              }
            } else if (typeof item[prop] == 'number') {
              let propValue = item[prop].toString().toLowerCase();
              let queryValue = str.toLowerCase();
              if (propValue.includes(queryValue)) {
                return true;
              }
            }
          }
        } else {
          if (typeof item[filter] == 'string') {
            let propValue = item[filter].toLowerCase();
            let queryValue = str.toLowerCase();
            if (propValue.includes(queryValue)) {
              return true;
            }
          } else if (typeof item[filter] == 'number') {
            let propValue = item[filter].toString().toLowerCase();
            let queryValue = str.toLowerCase();
            if (propValue.includes(queryValue)) {
              return true;
            }
          }
        }

        return false;
      });
    }
    state.mainGrid = listResult;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
